import type { AxiosPromise } from 'axios'
import request from '@core/request'

export type FileType = {
  id: string
  fileFormat: string
  fileSize: number
  fileName: string
  filePath: string
  result?: { filePath: string; fileFormat: string; success: boolean }
}
// 媒体新闻列表查询
export function listMedia(data: {
  pageIndex: number
  pageSize: number
  searchJsonData: any
}): AxiosPromise<{ sessionId: string; list: any[] }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/listMedia',
    method: 'post',
    data,
  })
}

export function listShopNews(data: {
  pageIndex: number
  pageSize: number
  searchJsonData: any
}): AxiosPromise<{ sessionId: string; list: any[] }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/shopNews/listShopNews',
    method: 'post',
    data,
  })
}

// 媒体新闻详细
export function getMedia(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/getMedia',
    method: 'post',
    data,
  })
}

export function ydylListMedia(data: unknown) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/ydylmedia/listMedia',
    method: 'post',
    data,
  })
}
export function getYdylMedia(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/ydylmedia/getMedia',
    method: 'post',
    data,
  })
}
// 联盟新闻获取详情
export function getShopNews(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/shopNews/getShopNews',
    method: 'post',
    data,
  })
}

// 获取联盟新闻发布结果
export function GetShopNewsPublishResult(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/shopNews/GetShopNewsPublishResult',
    method: 'post',
    data,
  })
}

// 导出发布结果
export function exportPublishResult(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/shopNews/exportPublishResult',
    method: 'post',
    responseType: 'blob',
    data,
  })
}

export function getMediaType(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/getMediaType',
    method: 'post',
    data,
  })
}

export function checkPubVideoCount(): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_API}`,
    url: '/tcloud-geo/video/checkPubVideoCount',
    method: 'post',
    data: {},
  })
}

// 获取各视频媒体当天已发布数量
export function getVideoMediaPubCount() {
  return request({
    baseURL: `${process.env.VUE_APP_API}`,
    url: '/tcloud-geo/video/GetVideoMediaPubCount',
    method: 'post',
    data: {},
  })
}

export function pubVideoMedia(data: {
  id?: number | string
  mediaIds: Array<number | string>
  title: string
  remark?: string
  keyword?: string
  desc?: string
  videoUrl?: string
  coverUrl?: string
  // 图片列表，支持最多上传30张图片（发布图文时使用）
  imagesUrls?: string[]
  // 0：视频 1：图片（发布图文时固定传1）
  pubType?: 0 | 1
  scheduledPublishTime?: string | null
  // 重新发布时传原发布单 MediaID
  rePubId?: string
}): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_API}`,
    url: '/tcloud-geo/video/pubVideoMedia',
    method: 'post',
    data,
  })
}

export function addMedia(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/addMedia',
    method: 'post',
    data,
  })
}
export function getOrdinaryMediaType(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/GetOrdinaryMediaType',
    method: 'post',
    data,
  })
}
export function getYdylOrdinaryMediaType(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/ydylmedia/GetOrdinaryMediaType',
    method: 'post',
    data,
  })
}
export function getSelfMediaType(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/GetSelfMediaType',
    method: 'post',
    data,
  })
}
// 海外媒体服务项列表（选媒体用）：itemType 10=海外媒体(海讯社/媒介易) 12=Reddit(Leadmore)，与发布 MediaType 同值
// 返回扁平 list（ItemID/Title/Price/Platform/PlatformName/ItemType/Remark），ItemID 即发布时的 mediaIDList
export function getOverseasServiceList(data: {
  platform?: number
  itemType?: number
  keyword?: string
}): AxiosPromise<{
  list: {
    ItemID: number
    Title: string
    Price: number
    Platform: number
    PlatformName: string
    ItemType: number
    Remark: string
  }[]
  total: number
}> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/OverseasMedia/GetOverseasServiceList',
    method: 'post',
    data,
  })
}
// 海外媒体发布记录列表（发布管理-发PR稿/发Reddit）：mediaType 10=海外媒体(海讯社/媒介易) 12=Reddit(Leadmore)
export function getOverseasMediaList(data: {
  pageIndex: number
  pageSize: number
  platform?: number
  mediaType?: number
  auditStatus?: number
  title?: string
  fromDate?: string
  toDate?: string
}): AxiosPromise<{
  total: number
  list: {
    MediaID: number
    Title: string
    Platform: number
    PlatformName: string
    AuditStatus: number
    GeoFileID: number
    TotalConsumeEquity: number
    Details: {
      DetailID: number
      SIID: number
      ResultUrl: string
      AuditStatus: number
      PlatformStatusText: string
    }[]
  }[]
}> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/OverseasMedia/GetOverseasMediaList',
    method: 'post',
    data,
  })
}
// 海外媒体发布详情（B-4）：前端只传 mediaID，聚合层已注入登录信息做归属校验
// 返回主表字段 + Details；明细行字段：ServiceTitle、AddDate(提交时间)、UpdateDate(状态变更时间)、
// PlatformStatusText(平台状态)、ResultUrl、AuditStatus、Remark 等
export function getOverseasMediaDetail(data: { mediaID: number }): AxiosPromise<any> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/OverseasMedia/GetOverseasMediaDetail',
    method: 'post',
    data,
  })
}

// 媒体新闻使用情况
export function getMediaUseInfo(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/media/getMediaUseInfo',
    method: 'post',
    data,
  })
}
export function getShopNewsUseInfo(data: any): AxiosPromise<{ sessionId: string }> {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/shopNews/getShopNewsUseInfo',
    method: 'post',
    data,
  })
}

export function keywordLibraryPageData(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/User_KeywordLibrary/Get_User_KeywordLibraryPageData',
    method: 'post',
    data,
  })
}

export function getSensitive(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/Speed_ArticleMaterial/GetSensitive',
    method: 'post',
    data,
  })
}
export function List_ContentData_Statistics(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/ContentData_Statistics/List_ContentData_Statistics',
    method: 'post',
    data,
  })
}
